export const PaymentOfferType = {
	PPV:          'ppv',
	PACKAGE:      'package',
	SUBSCRIPTION: 'subscription',
	EXTERNAL:     'external',
};
